module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-center align-items-center form-data"
  }, [_c('div', [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Add a new password")]), _vm._v(" "), _c('form', {
    class: ['shaded', _vm.status],
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updatePassword($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full",
    attrs: {
      "type": "password",
      "placeholder": "Please write a new password",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Update password"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "fs-smaller back",
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_vm._v("\n                Back to sign in\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-54f14b1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f14b1c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ResetPassword.vue
// module id = 1638
// module chunks = 0